const CouponAutomations = Object.freeze({
    RECALL: "Richiamare i tuoi clienti",
    APP: "Promuovere la tua App"
})

export default CouponAutomations
